module.exports = __webpack_public_path__ + "static/media/app-badge-app-store-small.d6b9ad28.svg";